import { defineAsyncComponent } from "vue"
export default defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/node_modules/nuxt-icon/dist/runtime/Icon.vue").then(r => r.default))